export default (data) => ({
  current: data.current_page,
  total: data.total,
  from: data.from,
  last: data.last_page,
  per: data.per_page,
  to: data.to
})
